<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="400px"
  >
    <template slot="dialogTitle">
      {{ countryDirty.name }} - settings
    </template>

    <v-card-text :class="{'pa-4': !$vuetify.breakpoint.xsOnly }">
      <v-switch
        v-model="countryDirty.chartering"
        label="Active charter bases"
      />

      <div v-if="countryDirty.chartering">
        <v-subheader>
          Charter End Date
        </v-subheader>
        <v-date-picker
          v-model="charterEndDate"
          class="elevation-5"
          full-width
          :min="$moment().startOf('year').format('YYYY-MM-DD')"
          :max="$moment().endOf('year').format('YYYY-MM-DD')"
          no-title
          :header-date-format="formatHeaderDate"
          :show-current="false"
        />
      </div>
    </v-card-text>

    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :loading="submitting"
        @click="save"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Save
      </v-btn>
    </template>
  </content-dialog>
</template>

<script>
  import Country from '@/models/Country'
  import ContentDialog from '@/components/helpers/Dialog'
  import { cloneDeep } from 'lodash'

  export default {
    name: 'CountryEditDialog',
    components: {
      ContentDialog
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      country: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        countryDirty: cloneDeep(this.country),
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      charterEndDate: {
        get: function () {
          if (!this.countryDirty.charter_end_date) return null

          return this.$moment(this.countryDirty.charter_end_date, 'MM-DD').format('YYYY-MM-DD')
        },
        set: function (value) {
          this.countryDirty.charter_end_date = this.$moment(value).format('MM-DD')
        }
      }
    },
    watch: {
      country() {
        this.countryDirty = cloneDeep(this.country)
      }
    },
    methods: {
      async save() {
        this.submitting = true

        try {
          await Country.api.updateCountry(this.countryDirty)
          this.$store.dispatch('settings/getCountries')
          this.$store.dispatch('alert', {
            'text': 'Successfully updated Country',
            'color': 'success'
          })
          this.modalVisible = false
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
        } finally {
          this.submitting = false
        }
      },
      formatHeaderDate(value) {
        return this.$moment(value).format('MMMM (MM)')
      }
    }
  }
</script>

<style>
  .v-text-field.v-text-field--enclosed .v-input__prepend-outer {
    margin: 0;
  }
</style>
